module.exports = __webpack_public_path__ + "static/media/prick_HMPG_header_image_02_600M.c40a82a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_header_image_02_600M.jpg
// module id = 351
// module chunks = 0